<template>
  <div class="container custom-mt">

    <!-- Bloqueia a tela enquanto aguarda a resposta do servidor:
         impede clicar em qualquer coisa (inclusive no NavBar) e reenviar -->
    <div v-if="sending" class="sending-overlay" role="alert" aria-live="assertive">
      <div class="sending-box text-center">
        <span class="spinner-border" role="status" aria-hidden="true"></span>
        <p class="mb-1 mt-3"><b>Salvando alterações...</b></p>
        <p class="small mb-0">
          Aguarde a resposta do servidor. Não feche nem recarregue a página.
        </p>
      </div>
    </div>

    <div class="card mx-auto border-0 shadow-lg" style="max-width: 500px">
      <div class="card-header bg-transparent border-0 ms-2">
        <div>
          <img
            src="../../assets/logo.png"
            alt="Logomarca"
            class="img-fluid mx-auto d-block mt-4"
            width="120"
          />
        </div>
      </div>

      <!-- Aviso de erro: fica fora dos painéis para aparecer também na tela de motivo -->
      <div class="text-white error-label text-center mx-3 mb-3" v-if="timeError" role="alert">
        <p class="">{{ errorLabel.messageError }}</p>
      </div>

      <div class="card-body" v-if="!confirm" >
        <h4 class="text-center mb-4">
          <b>Editar Serviço N° {{ process.id + 1000 }}</b>
        </h4>

        <div class="mb-4 ps-2 pe-2">
          <label for="nome" class="form-label">Cliente</label>

          <div>
            <div class="search-container">
              <span class="search-icon" v-if="!process.client && !searchTerm">
                <font-awesome-icon icon="magnifying-glass" />
              </span>
              <input
                v-model="searchTerm"
                @input="filterClients"
                :placeholder="getClientName(process.client)"
                class="form-control"
              />
              <span
                class="clear-icon"
                @click="clearSearch"
                v-if="process.client && $_store.state.userCurrent.type_user.includes('A') || $_store.state.userCurrent.type_user === 'D'"
              >
                <font-awesome-icon icon="circle-xmark" />
              </span>
            </div>
            <select
              class="form-control"
              v-model="process.client"
              size="3"
              v-if="searchTerm"
            >
              <option
                v-for="client in filteredClients"
                :key="client.id"
                :value="client.id"
              >
                {{ `${client.name} - ${client.fone}` }}
              </option>
            </select>
          </div>

          <p class="p-error-label">{{ errorLabel.client }}</p>
        </div>
        
        <div class="mb-3 ps-2 pe-2">
          <label for="nome" class="form-label">Material</label>

          <div>
            <div class="search-container">
              <span
                class="search-icon"
                v-if="!process.material && !searchTerm"
              >
                <font-awesome-icon v-if="!searchTermMaterial" icon="magnifying-glass" />
              </span>

              <input
                v-model="searchTermMaterial"
                @input="filterMaterials"
                :placeholder="getMaterialName(process.material)"
                class="form-control"
              />
              <span
                class="clear-icon"
                @click="clearMaterial"
                v-if="process.material && ($_store.state.userCurrent.type_user.includes('A') || $_store.state.userCurrent.type_user === 'D')"
              >
                <font-awesome-icon icon="circle-xmark" />
              </span>
            </div>
            <select
              class="form-control"
              v-model="process.material"
              size="3"
              v-if="searchTermMaterial"
            >
              <option
                v-for="material in filteredMaterials"
                :key="material.id"
                :value="material.id"
              >
                {{ `${material.name}` }}
              </option>
            </select>
          </div>
          <p class="p-error-label">{{ errorLabel.material }}</p>
        </div>

        <div class="mb-2 ps-2 pe-2 container-fluid">
          <label for="largura" class="form-label">Medidas do Material:</label>
          <div class="d-flex">

            <div class="row col me-1">
              <div class="col-12">
                <input
                  v-model="process.width"
                  type="number"
                  class="form-control mb-2"
                  id="largura"
                  placeholder="Largura (metros)"
                  style=""
                  :readonly=" ($_store.state.userCurrent.type_user.includes('A') || $_store.state.userCurrent.type_user === 'D') ? false : true"
                />
                <p class="p-error-label">{{ errorLabel.width }}</p>
              </div>
            </div>

            <div class="row col">
              <div class="col-12">
                <input
                  v-model="process.height"
                  type="number"
                  class="form-control"
                  id="altura"
                  placeholder="Altura (metros)"
                  style=""
                  :readonly=" ($_store.state.userCurrent.type_user.includes('A') || $_store.state.userCurrent.type_user === 'D') ? false : true"
                />
                <p class="p-error-label">{{ errorLabel.height }}</p>
              </div>
            </div>
          </div>
        </div>

        <div class=" ps-2 pe-2">
          <label for="quantidade" class="form-label">Quantidade:</label>
          <input
            v-model="process.amount"
            type="number"
            class="form-control"
            id="quantidade"
            placeholder="Quantidade"
            style="width: 200px;"
            :readonly=" ($_store.state.userCurrent.type_user.includes('A') || $_store.state.userCurrent.type_user === 'D') ? false : true"
          />
          <p class="p-error-label">{{ errorLabel.amount }}</p>
        </div>

        <div
          :class="` ps-2 pe-2 ${
            process.image ? 'd-flex align-items-center' : ''
          }`"
        >
          <div class="">
            <label for="formFileMultiple" class="form-label">Imagem</label>
            <input
              ref="fileInput"
              class="form-control"
              type="file"
              accept=".jpg,.jpeg,.pdf,.eps,image/jpeg,application/pdf,application/postscript"
              id="formFileMultiple"
              :disabled="sending"
              @change="handleFileChange"
              v-if="$_store.state.userCurrent.type_user !== 'I' "
            />
            <small class="text-muted d-block mt-1" v-if="$_store.state.userCurrent.type_user !== 'I'">
              Formatos aceitos: JPEG, PDF ou EPS
            </small>
            <p class="p-error-label">{{ errorLabel.image }}</p>
          </div>

          <div
            v-if="process.image"
            class="ms-4 mt-auto d-flex align-items-center justify-content-end flex-wrap"
          >
            <img
              v-if="process.fileType === 'image/jpeg'"
              :src="process.image"
              alt=""
              height="60"
              width="60"
            />

            <iframe
              v-else-if="process.fileType === 'application/pdf'"
              :src="process.image"
              width="60"
              height="60"
              style="background:white"
            ></iframe>

            <div v-else-if="isEpsFile" class="text-center">
              <div v-if="epsPreviewLoading" class="d-flex flex-column align-items-center">
                <span class="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span>
                <span class="mb-0 file-name-preview">Gerando prévia...</span>
              </div>

              <img
                v-else-if="epsPreview"
                :src="epsPreview"
                alt=""
                height="60"
                width="60"
              />

              <div v-else>
                <font-awesome-icon icon="file" size="2x" class="text-secondary" />
                <p class="mb-0 file-name-preview">{{ process.fileName }}</p>
                <span class="badge bg-secondary" style="font-size: 9px;">EPS</span>
              </div>
            </div>
          </div>
        </div>
        <p class=" ps-2 p-error-label">{{ errorLabel.image }}</p>

        <div class="mb-4 ps-2 pe-2" v-if=" ($_store.state.userCurrent.type_user.includes('A') || $_store.state.userCurrent.type_user === 'D')">
          <label for="finishing" class="form-label">Responsável Acabamento</label>
          <p v-if="!process.finishing">-</p>
          <input
            v-if="process.finishing"
            v-model="process.finishing"
            type="text"
            class="form-control"
            id="finishing"
            required
            placeholder="Digite o responsavél pelo acabamento"
          />
        </div>

        <div class="mb-4 ps-2 pe-2" v-if=" ($_store.state.userCurrent.type_user.includes('A') || $_store.state.userCurrent.type_user === 'D') || $_store.state.userCurrent.type_user === 'I'">
          <div v-if="!machineEdit"> 
            <label for="" class="form-label">Máquina</label>
            <p>
              {{ getNameMachine(process.machine) }} 
              <b class="text-primary clickable" @click="openMachineEdit"> editar <font-awesome-icon icon="pencil" /></b> 
            </p>
          </div>  

          <InputSelect
            v-if="machineEdit"
            :objetcSelect="machines"
            :setTitle="'Máquina'"
            :disabledClose="disabledClose($_store.state.userCurrent)"
            :setResult="process.machine"
            @objectId="machineValue"
          />
        </div>  

        <div :class="'ps-2 pe-3' + $_store.state.userCurrent.type_user !== 'A' ? 'mt-4 mb-2' : '' ">
          <label for="urgencia" class="form-label ms-2">Prioridade</label>
          <span v-if="$_store.state.userCurrent.type_user !== 'A'"><b>: Normal</b></span>
        </div> 
        <div class="mb-4 ps-2 pe-2 d-flex align-items-center" v-if=" ($_store.state.userCurrent.type_user.includes('A') || $_store.state.userCurrent.type_user === 'D')" >
          <div class="form-check me-4">
            <input
              v-model="process.status"
              class="form-check-input"
              type="radio"
              name="nomal"
              id="normal"
              value="N"
              checked
            />
            <label class="form-check-label" for="normal"> Normal </label>
          </div>
          <div class="form-check">
            <input
              v-model="process.status"
              class="form-check-input"
              type="radio"
              name="urgencia"
              id="urgente"
              value="U"
            />
            <label class="form-check-label" for="urgente"> Urgente </label>
          </div>
        </div>

        <div class="d-grid gap-2">
          <button class="btn btn-primary ms-2 me-2" @click="actionConfim" :disabled="ifModiflyProcess() || sending">
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="16"
              height="16"
              fill="currentColor"
              class="bi bi-arrow-bar-right"
              viewBox="0 0 16 16"
            >
              <path
                fill-rule="evenodd"
                d="M6 8a.5.5 0 0 0 .5.5h5.793l-2.147 2.146a.5.5 0 0 0 .708.708l3-3a.5.5 0 0 0 0-.708l-3-3a.5.5 0 0 0-.708.708L12.293 7.5H6.5A.5.5 0 0 0 6 8m-2.5 7a.5.5 0 0 1-.5-.5v-13a.5.5 0 0 1 1 0v13a.5.5 0 0 1-.5.5"
              />
            </svg>
            Confirmar
          </button>
          <button class="btn btn-outline-danger mb-4 ms-2 me-2" @click="back" :disabled="sending">
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="16"
              height="16"
              fill="currentColor"
              class="bi bi-arrow-bar-left"
              viewBox="0 0 16 16"
            >
              <path
                fill-rule="evenodd"
                d="M12.5 15a.5.5 0 0 1-.5-.5v-13a.5.5 0 0 1 1 0v13a.5.5 0 0 1-.5.5M10 8a.5.5 0 0 1-.5.5H3.707l2.147 2.146a.5.5 0 0 1-.708.708l-3-3a.5.5 0 0 1 0-.708l3-3a.5.5 0 1 1 .708.708L3.707 7.5H9.5a.5.5 0 0 1 .5.5"
              />
            </svg>
            Voltar
          </button>
        </div>
      </div>
      <div
        class="card text-center m-2"
        v-if="confirm"
        style="min-height: 280px"
      >
        <span class="mt-2">Para continuar, você precisa especificar o motivo desta edição:</span>
        <hr />
        <div class="ps-2 pe-2 mb-3">
            <label for="comment">Observação <small>(Obrigatório)</small></label>
            <textarea
              v-model="comment"
              class="form-control"
              id="comment"
              rows="3"
              :disabled="sending"
            >
            </textarea>
            
          </div>
        <div class="mt-1 mb-3">
          <button class="btn btn-danger btn-dm me-2" @click="actionConfim" :disabled="sending">
            Cancelar
          </button>

          <button
            type="button"
            class="btn btn-primary btn-dm me-2"
            @click="confirmReason"
            :disabled="comment.trim().length < 3 || sending"
          >
            <span
              v-if="sending"
              class="spinner-border spinner-border-sm"
              role="status"
              aria-hidden="true"
            ></span>
            {{ sending ? "Enviando..." : "Enviar" }}
          </button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { computed, onBeforeMount, onBeforeUnmount, ref } from "vue";
import { useRoute, onBeforeRouteLeave } from "vue-router";
import store from "../../store";
import { editProcess, getProcess, midiaConvertEps } from "../../http";
import { getReponseClients, getReponseMaterial, sendEventProcess, getReponseMachine,} from "../../socket";
import { getImgBase64, getNameObject} from "../../utils";
import InputSelect from "@/components/InputSelect.vue";
import _ from "lodash"

// Tempo máximo aguardando a resposta do servidor antes de liberar a tela.
// (generoso: upload de EPS/PDF grande pode demorar)
const SEND_TIMEOUT_MS = 5 * 60 * 1000;

const withTimeout = (promise, ms) => {
  let timer;
  const timeout = new Promise((_, reject) => {
    timer = setTimeout(() => reject(new Error("TIMEOUT")), ms);
  });
  return Promise.race([promise, timeout]).finally(() => clearTimeout(timer));
};

export default {
  name: "EditProcesses",
  props: {},
  setup() {
    const route = useRoute();
    const processId = ref(route.params.id || null);
    const clients = computed(() => store.state.clientsList);
    const materials = computed(() => store.state.materialList);
    const machines = computed(() => store.state.machineList);
    const timeError = ref(false);
    const confirm = ref(false);
    const sending = ref(false);
    const comment = ref('');
    const process = ref({});
    const processOrigin = ref({});
    const newFileSelected = ref(false); // só envia arquivo se o usuário escolheu um novo
    const errorLabel = ref({
      client: null,
      description: null,
      messageError: null,
      image: null,
      material: null,
      amount: null,
      height: null,
      width: null,
    });

    const isEpsFile = computed(() => {
      return process.value.fileType === "application/postscript" || process.value.fileType === "image/eps";
    });

    const epsPreview = ref(null);
    const epsPreviewLoading = ref(false);

    // ---------- mensagens de erro do envio ----------
    let errorTimer = null;

    const showError = (message, duration = 8000) => {
      errorLabel.value.messageError = message;
      timeError.value = true;
      clearTimeout(errorTimer);
      errorTimer = setTimeout(() => {
        timeError.value = false;
      }, duration);
      window.scrollTo({ top: 0, behavior: "smooth" });
    };

    const getErrorMessage = (err) => {
      if (err?.message === "TIMEOUT") {
        return "O servidor demorou para responder. Confira o histórico do serviço antes de tentar novamente.";
      }

      const noResponse =
        (err?.request && !err?.response) ||
        err?.code === "ERR_NETWORK" ||
        err instanceof TypeError;
      if (noResponse) {
        return "Falha de conexão ao enviar. Verifique a internet e tente novamente.";
      }

      let msg = err?.response?.data?.message ?? err?.message;
      if (Array.isArray(msg)) msg = msg.join(" ");
      return msg || "Não foi possível salvar as alterações. Tente novamente.";
    };

    // ---------- evita abortar o envio ao sair da tela ----------
    const warnBeforeUnload = (event) => {
      if (sending.value) {
        event.preventDefault();
        event.returnValue = "";
      }
    };
    window.addEventListener("beforeunload", warnBeforeUnload);

    onBeforeRouteLeave(() => {
      if (sending.value) {
        return window.confirm(
          "O envio ainda está em andamento. Se sair agora, as alterações podem não ser salvas. Deseja sair mesmo assim?"
        );
      }
    });

    onBeforeUnmount(() => {
      window.removeEventListener("beforeunload", warnBeforeUnload);
      clearTimeout(errorTimer);
    });

    const validateForm = () => {
      errorLabel.value.client = null;
      errorLabel.value.description = null;
      errorLabel.value.messageError = null;
      errorLabel.value.image = null;
      errorLabel.value.material = null;
      errorLabel.value.amount = null;
      errorLabel.value.height = null;
      errorLabel.value.width = null;

      if(!process.value?.material){
        errorLabel.value.material = "Campo obrigatório.";
      }

      if(!process.value?.image){
        errorLabel.value.image = "Campo obrigatório.";
      }

      if(!process.value?.amount){
        errorLabel.value.amount = "Campo obrigatório.";
      }

      if(!process.value?.height){
        errorLabel.value.height = "Campo obrigatório.";
      }

      if(!process.value?.width){
        errorLabel.value.width = "Campo obrigatório.";
      }

      if (!process.value?.client) {
        errorLabel.value.client = "Campo obrigatório.";
      }

      if (!process.value?.description) {
        errorLabel.value.description = "Campo obrigatório.";
      }

      if (errorLabel.value.client || 
          errorLabel.value.material ||
          errorLabel.value.amount ||
          errorLabel.value.height ||
          errorLabel.value.width
      ) {
        return true;
      }
      return false;
    };

    // Abre/fecha o painel de motivo. Valida ANTES de abrir, para o usuário
    // ver os erros nos campos em vez de travar na tela do motivo.
    const actionConfim = () => {
      if (sending.value) return;
      if (!confirm.value && validateForm()) return;
      confirm.value = !confirm.value;
    }

    const ifModiflyProcess = () => {
      if (_.isEqual(process.value, processOrigin.value)) {
        return true;
      }
      return false;
    }

    // Monta só o que o servidor usa. O arquivo (image/fileName/fileType) só vai
    // se o usuário escolheu um novo; a "image" carregada na tela é apenas a
    // PRÉVIA em baixa resolução e NÃO pode ser reenviada como se fosse o original.
    const buildPayload = () => {
      const p = process.value;
      const payload = {
        client: p.client,
        status: p.status,
        finishing: p.finishing,
        material: p.material,
        amount: p.amount,
        height: p.height,
        width: p.width,
        machine: p.machine,
        // o comentário vai junto na mesma requisição (mesma transação no servidor):
        // se falhar, nada é gravado, e reenviar não duplica o comentário
        comment: comment.value.trim(),
        member: store.state.userCurrent.id,
      };

      if (newFileSelected.value) {
        payload.image = p.image;
        payload.fileName = p.fileName;
        payload.fileType = p.fileType;
      }

      return payload;
    };

    const editProcesss = async () => {
      if (sending.value) return; // trava duplo clique / reenvio
      if (comment.value.trim().length < 3) return;

      if (validateForm()) {
        confirm.value = false; // volta ao formulário para mostrar os erros
        return;
      }

      sending.value = true;
      timeError.value = false;
      let succeeded = false;

      try {
        const responseProcess = await withTimeout(
          editProcess(process.value.id, buildPayload()),
          SEND_TIMEOUT_MS
        );

        if (!responseProcess?.status) {
          showError(getErrorMessage({ response: { data: responseProcess } }));
          return;
        }

        // falha no socket não pode virar "erro ao salvar": já foi salvo
        try {
          const updatedProcess = { ...responseProcess.process, updated: true, edit: 1 };
          sendEventProcess("graphic", updatedProcess);
        } catch (socketErr) {
          console.error(socketErr);
        }

        succeeded = true;
        window.removeEventListener("beforeunload", warnBeforeUnload);
        location.reload(); // a tela continua bloqueada até recarregar
      } catch (err) {
        console.error(err);
        showError(getErrorMessage(err));
      } finally {
        if (!succeeded) sending.value = false; // libera para tentar de novo
      }
    };

    const confirmReason = () => editProcesss();

    const back = () => {
      if (sending.value) return;
      store.commit("setOpenEditProcess");
    };

    const searchTerm = ref("");
    const searchTermMaterial = ref("");

    const filteredClients = computed(() => {
      const term = searchTerm.value.toLowerCase();
      return clients.value?.filter(
        (client) =>
          client.name.toLowerCase().includes(term) || client.fone.includes(term)
      );
    });

    const filteredMaterials = computed(() => {
      const term = searchTermMaterial.value?.toLowerCase();
      return materials.value?.filter(
        (material) =>
         material.name?.toLowerCase().includes(term)
      );
    });

    const getClientName = (clientId) => {
      if (!searchTerm.value && !process.value.client) {
        return "    Pesquisar cliente...";
      }

      const foundClient = clients.value.find(
        (client) => client.id === clientId
      );

      if (foundClient) {
        searchTerm.value = "";
        return foundClient ? foundClient.name + " - " + foundClient.fone : "";
      }
    };

    const getMaterialName = (materialId) => {
      if (!searchTermMaterial.value && !process.value.material) {
        return "    Pesquisar material...";
      }

      const foundMaterial= materials.value.find(
        (material) => material.id === materialId
      );

      if (foundMaterial) {
        searchTermMaterial.value = "";
        return foundMaterial ? foundMaterial.name : "";
      }
    };

    const clearSearch = () => {
      searchTerm.value = "";
      process.value.client = null;
    };

    const clearMaterial = () => {
      searchTermMaterial.value = "";
      process.value.material = null;
    };

    const filterClients = () => {};
    const filterMaterials = () => {};

    const ALLOWED_EXT = ['.jpg', '.jpeg', '.pdf', '.eps'];

    const loadEpsPreview = async (base64Image) => {
      epsPreview.value = null;
      epsPreviewLoading.value = true;

      try {
        const response = await midiaConvertEps({ image: base64Image });
        if (response?.status && response?.image) {
          epsPreview.value = response.image;
        }
      } catch (err) {
        epsPreview.value = null;
      } finally {
        epsPreviewLoading.value = false;
      }
    };

    // Volta para a prévia que veio do servidor (usuário cancelou ou escolheu arquivo inválido)
    const restoreOriginalFile = () => {
      process.value.image = processOrigin.value.image ?? null;
      process.value.fileName = processOrigin.value.fileName ?? null;
      process.value.fileType = processOrigin.value.fileType ?? null;
      newFileSelected.value = false;
      epsPreview.value = null;
      epsPreviewLoading.value = false;
    };

    const fileInput = ref(null);
    const handleFileChange = (event) => {
      errorLabel.value.image = null;
      epsPreview.value = null;
      epsPreviewLoading.value = false;
      newFileSelected.value = false;

      const inputEl = event.target;
      const file = inputEl.files[0];

      if (!file) {
        restoreOriginalFile();
        return;
      }

      const ext = '.' + file.name.split('.').pop().toLowerCase();

      if (!ALLOWED_EXT.includes(ext)) {
        inputEl.value = null;
        restoreOriginalFile();
        errorLabel.value.image = "Formato não suportado. Envie um arquivo JPEG, PDF ou EPS.";
        return;
      }

      const reader = new FileReader();

      reader.onload = () => {
        process.value.image = reader.result;
        process.value.fileName = file.name;
        process.value.fileType = file.type || (ext === '.eps' ? 'application/postscript' : '');
        newFileSelected.value = true;

        if (process.value.fileType === 'application/postscript' || ext === '.eps') {
          loadEpsPreview(reader.result);
        }
      };

      reader.onerror = () => {
        inputEl.value = null;
        restoreOriginalFile();
        errorLabel.value.image = "Não foi possível ler o arquivo. Tente novamente.";
      };

      reader.readAsDataURL(file);
    };

    const openCreateMaterial = () => {
      store.commit('setOpenCreateMaterial');
    }

    const disabledClose = (user) => {
      return user.type_user === 'C'
    }

    const machineValue = (event) => {
      process.value.machine = event
    }

    const getMachine = ({machine}) => {
      return process.value.machine || machine
    }

    const getNameMachine = (id) =>{
      return getNameObject(store.state.machineList, id)
    }

    const machineEdit = ref(false);

    const openMachineEdit = () => {
      machineEdit.value = machineEdit.value ? false : true ;
    }

    onBeforeMount(async () => {
      if (processId.value) {
        await getProcess(processId.value).then( async (data) => {
          process.value = data;
          try {
            process.value.image = await getImgBase64(processId.value);
          } catch (err) {
            console.error(err);
            process.value.image = null;
          }
          process.value.fileType = process.value.fileType || 'image/jpeg';
        });  
      }

    processOrigin.value = {...process.value};
      await store.dispatch("setClientListCurrent");
      await store.dispatch("setMaterialListCurrent");
      await store.dispatch("setMachineListCurrent");
      getReponseMaterial();
      getReponseClients();
      getReponseMachine();
    });

    return {
      openMachineEdit,
      machineEdit,
      getNameMachine,
      getMachine,
      disabledClose,
      machineValue,  
      machines,
      openCreateMaterial,
      handleFileChange,
      fileInput,
      filterMaterials,
      clearMaterial,
      filteredMaterials,
      getMaterialName,
      searchTermMaterial,
      filteredClients,
      filterClients,
      searchTerm,
      clearSearch,
      getClientName,
      editProcesss,
      process,
      processOrigin,
      back,
      clients,
      errorLabel,
      timeError,
      actionConfim,
      confirm,
      sending,
      confirmReason,
      comment,
      ifModiflyProcess,
      isEpsFile,
      epsPreview,
      epsPreviewLoading,
    };
  },
  components:{
    InputSelect
  }
};
</script>

<style scoped>
h1 {
  font-weight: bold;
}
h1,
label,
button {
  font-family: Arial, Helvetica, sans-serif;
}

.custom-mt {
  margin-top: 10px;
  margin-bottom: 80px;
}

h1 {
  display: flex;
  align-items: center;
  justify-content: center;
}
.error-label {
  background-color: #be3f3f;
  border-radius: 5px;
  overflow: hidden;
}

.p-error-label {
  font-size: 14px;
  color: red;
}

.search-container {
  position: relative;
}

.search-icon {
  position: absolute;
  left: 10px;
  top: 50%;
  cursor: pointer;
  transform: translateY(-50%);
  color: #888;
}

.clear-icon {
  position: absolute;
  right: 10px;
  top: 50%;
  cursor: pointer;
  transform: translateY(-50%);
  color: #888;
}
.custom-link {
  font-size: 15px;
  color: gray;
  font-weight: bold;
  text-decoration: none;
  transition: color 0.3s, background-color 0.3s;
}

.custom-link:hover {
  color: #020202;
  font-weight: bold;
}


.clickable {
  cursor: pointer;
}

.file-name-preview {
  font-size: 10px;
  max-width: 70px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.sending-overlay {
  position: fixed;
  inset: 0;
  z-index: 2000; /* acima do NavBar e de modais */
  display: flex;
  align-items: center;
  justify-content: center;
  background: rgba(0, 0, 0, 0.55);
}

.sending-box {
  background: #fff;
  border-radius: 10px;
  padding: 24px 32px;
  max-width: 320px;
  box-shadow: 0 10px 30px rgba(0, 0, 0, 0.3);
}
</style>